import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import GrainOverlay from "@/components/GrainOverlay";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Film from "@/components/Film";
import Showreel from "@/components/Showreel";
import Craft from "@/components/Craft";
import Services from "@/components/Services";
import Pipeline from "@/components/Pipeline";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <ReactLenis root options={{ duration: 1.4, smoothWheel: true, anchors: true }}>
      <div className="App bg-[#050505] text-white min-h-screen">
        <GrainOverlay />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Film />
          <Showreel />
          <Craft />
          <Services />
          <Pipeline />
          <Clients />
          <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-center" />
      </div>
    </ReactLenis>
  );
}
